import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/product.js';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { connect } from "react-redux";
import { getProducts, showLoading, hideLoading } from '../../redux/actions/product';

const Product = () => {
    const products = useSelector(state => state.allProducts.products);

    const dispatch = useDispatch();

    useEffect(() => {
        document.title = "Our Experience | REAL FM";
    },[]);

    useEffect(() => {
        const fetchAllProducts = async () => {
            dispatch(showLoading());
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/products/find-all`).then((res) => {
                dispatch(getProducts(res.data));
                dispatch(hideLoading());

            }).catch(error => {
                console.error(error);
            });
            //dispatch(getProducts(response.data));
        };
        fetchAllProducts();
    }, [dispatch]);

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper product-page">

                {/* Header 2 */}
                <HeaderTwo />


                {/* Breadcroumb */}
                <BreadcrumbBox title="Our Experience" />

                {/* Products */}
                <section className="product-area">
                    <Container className="card custom-card">
                        <Row>
                            <Col lg="12" md="12" sm="12">
                                <Row>
                                    {
                                        products !==null && products.length > 0 ? products.map((data, i) => (
                                            <Col lg="4" md="6" key={i}>
                                                <div className="product-box">
                                                    <div className="product-img">
                                                        <img src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${data.productImg.substring(data.productImg.indexOf("/uploads"))}`} alt={data.productTitle} className="img-fluid" />
                                                        {/* <img src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `/${data.productImg}`} alt="" className="img-fluid" /> */}
                                                        <div className="layer-box"></div>
                                                        
                                                    </div>
                                                    <div className="product-content text-center">
                                                        <div className="pro-title">
                                                            <h5>{data.productTitle}</h5>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </Col>
                                        )): "No products found"
                                    }

                                </Row>                                
                            </Col>

                        </Row>
                    </Container>
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    )
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(Product);